import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Provider bottom-tab navigation. Order matches the mobile app (task #660):
//   1. Buyurtmalar  2. Daromad  3. Bildirishnomalar  4. Profil
const TABS = [
  { label: 'Buyurtmalar', icon: '📦', path: '/provider/orders' },
  { label: 'Daromad', icon: '💰', path: '/provider/earnings' },
  { label: 'Bildirishnomalar', icon: '🔔', path: '/provider/notifications' },
  { label: 'Profil', icon: '👤', path: '/provider/profile' },
];

export default function ProviderLayout({ title, children }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={s.shell}>
      <header style={s.header}>
        <span style={s.headerTitle}>{title}</span>
      </header>

      <main style={s.main}>{children}</main>

      <nav style={s.tabBar} aria-label="Asosiy menyu">
        {TABS.map((tab) => {
          const active = location.pathname === tab.path;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              style={{ ...s.tab, ...(active ? s.tabActive : {}) }}
            >
              <span style={{ ...s.tabIcon, opacity: active ? 1 : 0.55 }}>{tab.icon}</span>
              <span style={{ ...s.tabLabel, color: active ? PRIMARY : '#94A3B8' }}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}

const PRIMARY = '#4F46E5';

const s = {
  shell: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#F8FAFC',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    maxWidth: '520px',
    margin: '0 auto',
    boxShadow: '0 0 24px rgba(0,0,0,0.06)',
  },
  header: {
    background: 'var(--surface)',
    padding: '16px',
    borderBottom: '1px solid #E2E8F0',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  headerTitle: { fontSize: '18px', fontWeight: '700', color: 'var(--slate-900)' },
  main: { flex: 1, padding: '16px', paddingBottom: '84px' },
  tabBar: {
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: 0,
    width: '100%',
    maxWidth: '520px',
    display: 'flex',
    background: 'var(--surface)',
    borderTop: '1px solid #E2E8F0',
    height: '64px',
    zIndex: 20,
  },
  tab: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '6px 2px',
  },
  tabActive: { background: '#EEF2FF' },
  tabIcon: { fontSize: '20px', lineHeight: 1 },
  tabLabel: { fontSize: '11px', fontWeight: '600' },
};
